import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
	root: {},
	arrowLeft: {
		cursor: 'pointer',
	},
}));
